// Typelizer digest e7ce1d4125217fd4f8cf2b16832e7210
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../../runtime'
import { buildUrl } from '../../../runtime'

export default {
  /** DELETE /c/:company_id/ledger/periods/:period_id/approval */
  destroy: (
    params: { periodId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/c/:company_id/ledger/periods/:period_id/approval', params, options),
    method: 'delete',
  }),

  /** POST /c/:company_id/ledger/periods/:period_id/approval */
  create: (
    params: { periodId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/ledger/periods/:period_id/approval', params, options),
    method: 'post',
  }),
}
